import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dtfc7uc37e: FaireBrandEntity = {
  token: "b_dtfc7uc37e",
  type: "brand",
  name: "Aaron Probyn US",
  avatarUrl:
    "https://cdn.faire.com/fastly/d6a66c503562ed2f5d0c01b072c7ce5579b9945ed1399057bb2718e51df90d29.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c86cbc52791e47b04a1810031d3abf98cbb028c943310f40ea2e0318782caea9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d6a66c503562ed2f5d0c01b072c7ce5579b9945ed1399057bb2718e51df90d29.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c86cbc52791e47b04a1810031d3abf98cbb028c943310f40ea2e0318782caea9.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 14,
  isTopShop: true,
  isInsider: true,
  description:
    "GOOD DESIGN FOR DAILY LIFE\n\nAaron Probyn was founded on the principle that good design lasts a lifetime.\n\nOur cohesive range of beautifully designed products is intended to be both useful and emotionally engaging. Be it a wine glass or a soup spoon, we create objects that enrich the everyday.\n\nWith near 20 years of experience working alongside global design brands, we have established a manufacturing network that can deliver on our promise of fine craftsmanship and sustainability. Conscious design leads to conscious living and we strive to ensure every new product in our collection has minimal impact upon the environment.\n\nWe supply wholesale to independent retailers and direct to consumers that share our passion for design excellence.\n\nENVIRONMENTAL IMPACT\n\nAs a design practice, we believe in designing products to last a lifetime, and their packaging to leave no trace. We use the finite raw materials we have on this earth wisely and hope that whoever purchases our product would enjoy it for years to come, and potentially pass it on to another generation.\n\nWe ensure the packaging of our products has as little impact on the environment as possible. We are reducing box sizes, print use, removing single plastic use where possible, and using unbleached recyclable card.",
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:52:18.128Z",
    importedBy: "entity-db-cli",
  },
};
